import * as React from 'react';
import './ProgressBarStyles.css';
import * as classNames from "classnames";
import { DcfRequestStatus } from 'webportalclient';
import { DcfSystemWorkflow } from '../../misc/api/apiTypes';

export interface DataCorrectionProgressBarProps {
    statuses: Array<DcfRequestStatus>;
    currentStatusId: string;
    systemWorkflow: DcfSystemWorkflow;
    siteId: string
}

export const DataCorrectionProgressBar = (props: DataCorrectionProgressBarProps) => {
    const statuses = [...props.statuses].filter(x => (props.systemWorkflow !== DcfSystemWorkflow.Implementation || x.id !== "DCF_APPROVED") && (props.siteId || x.id !== "DCF_SITE_REVIEW"))
    .sort((a, b) => a.order - b.order);
    const currentIndex = statuses.findIndex(x => x.id == props.currentStatusId);


    
    return (
        <div className="row" style={{ borderBottom: 0 }}>
            <div className="col-md-12 dcf-progress">
            {statuses.map((s, index) => {
                const classes = classNames("col-xs-2", "dcf-progress-step", { "active": index === currentIndex }, { "complete": index < currentIndex }, { "disabled": index > currentIndex });

                return (
                    <div key={s.order} className={classes}>
                        <div className="dcf-progress-stepnum text-center">{s.name}</div>
                        <div className="progress"><div className="progress-bar"></div></div>
                        <span className="dcf-progress-dot"></span>
                    </div>
                );
                })}
            </div>
        </div>
    );
}
